<style>
#comment {
    border-top: 1px solid #eee;
    padding-top: 15px;
    padding-bottom: 15px;
    word-wrap: break-word;
}

#username {
    color: #999;
    font-size: 12px;
}

.control {
    cursor: pointer;
    margin-left: 3px;
}

#controls {
    display: inline-block;
    margin-left: 10px;
}

.deleted {
    opacity: 0.3;
}

.comment-createtime-link {
    color: grey;
}

.badge {
    padding: 1px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 15px;
    margin-left: 5px;
    margin-right: 5px;
    background-color: rgb(123, 123, 123);
    color: white;
}

.props {
    font-weight: bold;
    color: rgb(70, 70, 70);
}

.new-controls {
    margin-top: 10px;
    width: 100%;
}

.control {
    color: grey;
    border:1px solid rgb(223, 223, 223);
    border-radius: 15px;
    font-size: 12px;
    display: inline-flex;
    flex-direction: row;
    line-height: 1em;
    overflow: hidden;
}

.control-number {
    padding: 3px;
    padding-left: 5px;
    border-right: 1px solid rgb(223, 223, 223);
}

.control-button {
    padding: 3px;
    padding-right: 5px;
}

.control-single {
    color: grey;
    border:1px solid rgb(223, 223, 223);
    border-radius: 15px;
    font-size: 12px;
    line-height: 1em;
    display: inline-block;
    padding: 3px;
    padding-left: 5px;
    padding-right: 5px;
}

.control-single:hover {
    background-color: #ebebf3;
    color: grey;
}

.control-button:hover {
    background-color: #ebebf3;
    color: grey;
}

</style>

<script>
import {push} from './pt-router/Router.svelte'
import * as Common from './Common.js'
import AddCommentWidget from './AddCommentWidget.svelte'
import ReplyComments from './ReplyComments.svelte'
import Spinner from './Spinner.svelte'

export let commentId;
export let removeCommentFromParent;

import { getContext } from 'svelte';
const { open } = getContext('simple-modal');
import ShareSheetModal from './Sharing/ShareSheetModal.svelte'

let comment = null;
let currentUser;
let showControls = false;
let showReplyBox = false;

$: commentId && function() {
    Common.getData('comment/' + commentId)
    .then(data => {
        comment = data
    })
}()

const unsubsribe = Common.currentUser.subscribe(value => {
    currentUser = value
})

function showReplyButton() {
    showControls = true;
}
function hideReplyButton() {
    showControls = false;
}

function addComment(newComment) {
    Common.addCommentToComment(comment, newComment, (new_comment_id) => {
        comment.replies = comment.replies.concat(Number(new_comment_id))
        hideWidget()
    })
    return
}

function reportComment() {
    if(!currentUser) {
        Common.loginContext.update(v => "item/" + comment.item_id)
        Common.CreateNotification({body: "You must login to contribute!"}, 1000)
        push('/login')
        return;
    }

    let details = window.prompt("Please provide details as to why you are reporting this comment:","Details go here.");
    if(details.length == 0) {
        return;
    }
    let report = {
        user_id : currentUser.user_id,
        type : Common.REPORTTYPE_COMMENT,
        body : details,
        ref_id : comment.id
    }
    fetch(
    'API_URL/report',
    {
        method: "POST",
        body: JSON.stringify(report),
        headers: new Headers({'content-type': 'application/json'}),
        credentials: "include"
    })
    .then(r => {
        if(r.status != 200) {
            alert("Problem reporting. Please contact support.")
            return
        }
        alert("Successfully Reported Comment. Thank You.")
    })
}

function deleteComment() {
    let confirmed = window. confirm("Are you sure you want to delete this comment? It's contents will be cleared");
    if(!confirmed) {
        return;
    }
    fetch(
    'API_URL/comment/' + comment.id,
    {
        method: "DELETE",
        headers: new Headers({'content-type': 'application/json'}),
        credentials: "include"
    })
    .then(r => {
        if(r.status != 200) {
            alert("Problem deleting comment.")
            return
        }
        comment.content = ""
    })
}

function trylikeComment() {
    if(!currentUser) {
        Common.loginContext.update(v => "comment/" + comment.id)
        Common.CreateNotification({body: "You must login to contribute!"}, 1000)
        push('/login')
        return;
    }

    Common.trylikeComment(comment.id, () => {
        comment.likes += 1;
    })
}

function showWidget() {
    if(!currentUser) {
        Common.loginContext.update(v => "item/" + comment.item_id)
        Common.CreateNotification({body: "You must login to contribute!"}, 1000)
        push('/login')
    }

    showReplyBox = true;
}

function hideWidget() {
    showReplyBox = false;
}

function showShareWidget() {
    open(ShareSheetModal, {
        link: "https://plantogether.city/comment/" + comment.id,
        shareString: comment.user_name + "'s Comment on " + comment.item_title},
    {content: { fontSize: '14px', lineHeight: '1.5em'}});
}

</script>

{#if comment}
    <div id="comment" class="rich-content-holder">
        <div class={comment.content.length == 0 ? "deleted" : ""}>
            <div id="username">
            {#if !comment.user_name}
                <strong>Deleted User</strong>
            {:else}
                <a style={comment.user_area_name ? "color: rgb(123, 123, 123); font-weight: bold" : ""} href={"#/user/" + comment.user_id}>{comment.user_name}</a>
                {#if comment.user_area_name}<span class="badge">{comment.user_area_name} Offical</span>{/if}
                {#if comment.user_special}<span class="badge">{Common.getSpecialStr(comment.user_special)}</span>{/if}

            {/if}
            <a class="comment-createtime-link" href={"#/comment/" + comment.id}>
                {Common.UnixTimeToDateStr(comment.createtime)}
            </a>
            </div>
                {#if comment.content.length != 0}
                    {@html comment.screened ? Common.sanitizeContent(comment.content) : Common.ReplaceImagesIfNeeded(Common.sanitizeContent(comment.content))}
                {:else}
                    <i>Comment Deleted.</i>
                {/if}
        </div>
        <div class="new-controls">
            <div class="control">
                <div class="control-number">{comment.likes}</div>
                <div class="control-button" on:click={trylikeComment}>Like</div>
            </div>
            <div class="control-single" on:click={showWidget}>Reply</div>
            <div class="control-single" on:click={showShareWidget}>Share</div>
            <div class="control-single" on:click={reportComment}>Report</div>
            {#if currentUser && currentUser.user_id == comment.user_id}
                <div class="control-single" on:click={deleteComment}>Delete</div>
            {/if}
        </div>
        {#if showReplyBox}
            <AddCommentWidget {hideWidget} {addComment}></AddCommentWidget>
        {/if}
        <ReplyComments item_id={comment.item_id} comments={comment.replies}></ReplyComments>
    </div>
{:else}
    <Spinner></Spinner>
{/if}